import {View, Image, Text} from 'react-native';
import React from 'react';
import {CircularProgressbarWithChildren} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {FONT_FAMILY_REGULAR, isMobileWeb, white} from '../../utils/utils';

export const UICircularProgress = props => {
   const percentage = Math.round(props.fill ?? 0);
   const WIDTH = props.circleWidth ?? props.size ?? 160;
   const HEIGHT = props.circleHeight ?? props.size ?? 160;
   const strokeWidth = props.width ?? (isMobileWeb ? 10 : 12);
   const imgWidth = props.imgWidth ?? 48;
   const imgHeight = props.imgHeight ?? 51;
   const showPercent = props.showPercent ?? true;
   const tintColor = props.tintColor ?? '#26E555';
   const bgColor = props.backgroundColor ?? '#1C222B';
   const trailStroke = props.trailStroke ?? '#003DA5';
   const img = props.img ?? require('../../assets/course.png');
   const background = props.background ?? true;
   const trailOpacity = props.trailOpacity ?? 1;
   const onlyPercentage = props.onlyPercentage ?? false;
   const percentFont = props.percentFont ?? 12;
   const bgOpacity = props.bgOpacity ?? 0.6;
   const imgTintClr = props.imgTintClr ?? '#6E8EFF';
   const shadowColor = props.shadowColor ?? 'transparent';
   const fontWeight = props.fontWeight ?? '500';
   const iconBottomMargin = props.iconBottomMargin ?? null;
   const iconTopMargin = props.iconTopMargin ?? null;
   const applyPadding = props.applyPadding ?? false;
   return (
      <View
         style={{
            width: WIDTH,
            height: HEIGHT,
            shadowColor: shadowColor,
            shadowOffset: {width: 0, height: 0},
            shadowOpacity: 0.7,
            shadowRadius: 0,
         }}>
         <CircularProgressbarWithChildren
            minValue={0}
            maxValue={100}
            value={percentage}
            strokeWidth={strokeWidth}
            //circleRatio={0.5}
            //background="red"
            background={background}
            backgroundColor={bgColor}
            styles={{
               filter: 'blur(20x)',
               background: {
                  fill: bgColor,
                  opacity: bgOpacity,
               },
               path: {
                  // Path color
                  stroke: tintColor,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: 'butt',
                  // Customize transition animation
                  //transition: 'stroke-dashoffset 0.5s ease 0s',
                  // Rotate the path
                  //transform: 'rotate(0.25turn)',
                  transformOrigin: 'center center',
               },
               trail: {
                  // Trail color
                  stroke: trailStroke,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: 'butt',
                  // Rotate the trail
                  transform: 'rotate(0.29turn)',
                  transformOrigin: 'center center',
                  strokeWidth: strokeWidth,
                  opacity: trailOpacity,
               },
               text: {
                  // Text color
                  fill: 'red',
                  // Text size
                  fontSize: '16px',
               },
            }}
         />
         <View
            style={{
               position: 'absolute',
               alignItems: 'center',
               justifyContent: 'center',
               width: WIDTH,
               height: HEIGHT,
            }}>
            {!onlyPercentage && (
               <Image
                  source={img}
                  style={{
                     width: imgWidth,
                     height: imgHeight,
                     color: imgTintClr,
                     marginBottom: iconBottomMargin,
                     marginTop: iconTopMargin,
                  }}
               />
            )}
            {showPercent && (
               <Text
                  style={{
                     fontSize: percentFont,
                     color: white,
                     fontWeight: fontWeight,
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  {percentage}%
               </Text>
            )}
         </View>
      </View>
   );
};

export default UICircularProgress;
